import { getLangBasedOnCity } from '../../utils/cityUtils';

const en_meta = {
  community_home_meta_title:
    'Ron’s Community – Ask, Share & Connect with Others',
  community_home_meta_description:
    'Join the conversation! Ask questions, share ideas, get advice, and connect with like-minded people in a friendly, urban community.',
  ask_zurich_en_meta_title: 'Ron’s Community – Explore Trending Topics',
  ask_zurich_en_meta_description:
    'Join the conversation in this popular category of Ron’s Community! Share your insights, ask questions, and connect with fellow enthusiasts.',
  ask_swiss_meta_title: 'Ron’s Community – Search & Offer Help or Services',
  ask_swiss_meta_description:
    'Looking for help or offering something? This space is for sharing services, getting support, and helping others in the community.',
  together_meta_title: 'Ron’s Community – Discover & Share Local Events',
  together_meta_description:
    'Looking for something to do? Explore community-posted events, activities, and gatherings – or share your own with others nearby.',
  love_meta_title: 'Ron’s Community – Explore Trending Topics',
  love_meta_description:
    'Join the conversation in this popular category of Ron’s Community! Share your insights, ask questions, and connect with fellow enthusiasts.',
  phototrip_meta_title: 'Ron’s Community – Explore Trending Topics',
  phototrip_meta_description:
    'Join the conversation in this popular category of Ron’s Community! Share your insights, ask questions, and connect with fellow enthusiasts.',
  ronster_help_ronster_meta_title:
    'Ron’s Community – Search & Offer Help or Services',
  ronster_help_ronster_meta_description:
    'Looking for help or offering something? This space is for sharing services, getting support, and helping others in the community.',
  my_area_meta_title: 'Ron’s Community – Explore Trending Topics',
  my_area_meta_description:
    'Join the conversation in this popular category of Ron’s Community! Share your insights, ask questions, and connect with fellow enthusiasts.',
  rons_tips_home_meta_title:
    'Ron’s Tips – Smart Ideas & Local Insights You’ll Love',
  rons_tips_home_meta_description:
    'Get inspired with Ron’s best tips! Discover fun ideas, local secrets, and cool places to eat, drink, shop, and explore wherever you are.',
  market_home_meta_title: 'Ron’s Market – Discover Offers, Events, Jobs & More',
  market_home_meta_description:
    'Browse the latest from the community! Find events, services, jobs, gigs, and unique listings – or post your own to share with others.',
  rons_tips_guides_meta_title:
    'Ron’s Tips Guides – Best Tips, Hacks & Inspiration',
  rons_tips_guides_meta_description:
    'Browse Ron’s most popular guides! Find curated tips, helpful hacks, and lifestyle inspiration to make everyday life more exciting.',
  rons_tips_family_life_meta_title:
    'Family Life with Ron – Activities, Tips & Everyday Joy',
  rons_tips_family_life_meta_description:
    'Discover fun ideas and helpful tips for families! From weekend outings and parenting hacks to creative activities for kids and adults alike.',
  rons_tips_family_life_diy_meta_title:
    'Ron’s DIY Ideas – Creative Projects for All Ages',
  rons_tips_family_life_diy_meta_description:
    'Get inspired with fun DIY projects! From crafts and home hacks to upcycling and hands-on ideas for kids, adults, and families.',
  rons_tips_family_life_finance_meta_title:
    'Ron’s Family Finance Tips – Save Smart & Live Well',
  rons_tips_family_life_finance_meta_description:
    'Discover practical money tips for families! Learn about budgeting, smart spending, saving tricks, and managing everyday family finances.',
  rons_tips_family_life_parenthood_meta_title:
    'Ron’s Parenthood Tips – Support, Stories & Smart Advice',
  rons_tips_family_life_parenthood_meta_description:
    'Discover helpful tips and shared experiences for parents! From parenting hacks and emotional support to everyday wins and real-life moments.',
  rons_tips_family_life_podcasts_meta_title:
    'Ron’s Family Podcasts – Listen, Learn & Laugh Together',
  rons_tips_family_life_podcasts_meta_description:
    'Tune in to podcast picks for families! Enjoy inspiring talks, helpful parenting tips, and fun stories for both kids and grown-ups.',
  rons_tips_family_life_trips_meta_title:
    'Ron’s Family Trips – Getaways, Day Tours & Nature Fun',
  rons_tips_family_life_trips_meta_description:
    'Find fun family-friendly trip ideas! From weekend escapes and nature walks to nearby adventures for kids and parents alike.',
  rons_tips_family_life_inspiration_meta_title:
    'Ron’s Family Inspiration – Ideas to Spark Everyday Joy',
  rons_tips_family_life_inspiration_meta_description:
    'Explore uplifting content for families! Get inspired by creative thoughts, real stories, and thoughtful tips for joyful family life.',
  rons_tips_city_life_meta_title:
    'Ron’s City Life Guides – Explore Urban Culture & Daily Fun',
  rons_tips_city_life_meta_description:
    'Dive into Ron’s favorite city life tips! Discover local culture, cool places, lifestyle hacks, and inspiration for making everyday life exciting.',
  rons_tips_whats_up_meta_title: "What's Up",
  rons_tips_whats_up_meta_description: "What's Up",
  rons_tips_balance_day_meta_title: 'Balance Day',
  rons_tips_balance_day_meta_description: 'Balance Day',
  rons_tips_pastime_meta_title:
    'Pastime by Ron – Hobbies, Fun & Free Time Ideas',
  rons_tips_pastime_meta_description:
    'Discover fun ways to spend your free time! Ron’s pastime tips cover hobbies, relaxing activities, and cool things to do after work or on weekends.',
  rons_tips_ron_voyage_meta_title: 'Ron Voyage',
  rons_tips_ron_voyage_meta_description: 'Ron Voyage',
  rons_tips_roncast_meta_title: 'Roncast – Listen, Learn & Stay Inspired.',
  rons_tips_roncast_meta_description:
    'Tune into Roncast for fresh perspectives, local stories, lifestyle trends, and creative inspiration – anytime, anywhere.',
  rons_tips_rooftop_day_meta_title: 'Rooftop Day',
  rons_tips_rooftop_day_meta_description: 'Rooftop Day',
  rons_tips_streetfood_tour_meta_title: 'Streetfood Tour',
  rons_tips_streetfood_tour_meta_description: 'Streetfood Tour',
  rons_tips_whats_happening_meta_title:
    'Ron’s Events – Unique Happenings & Local Highlights',
  rons_tips_whats_happening_meta_description:
    'Stay updated with Ron’s event picks! Discover cool happenings, cultural events, and fun things to experience around you.',
  rons_tips_rons_events_meta_title:
    'Ron’s Events – Unique Happenings & Local Highlights',
  rons_tips_rons_events_meta_description:
    'Stay updated with Ron’s event picks! Discover cool happenings, cultural events, and fun things to experience around you.',
  rons_tips_food_and_shop_meta_title:
    'Food & Shopping by Ron – Tasty Spots & Hidden Stores',
  rons_tips_food_and_shop_meta_description:
    'Explore Ron’s picks for food and shopping! Discover delicious places to eat, cozy cafés, local markets, and hidden shops worth visiting.',
  rons_tips_food_and_drinks_meta_title:
    'Ron’s Food & Drinks – Tasty Finds & Local Flavor',
  rons_tips_food_and_drinks_meta_description:
    'Discover Ron’s favorite food & drink spots! From cozy cafés and trendy bars to hidden restaurants – perfect for every craving.',
  rons_tips_new_in_town_meta_title:
    'New in Town – Fresh Places, New Openings & Cool Spots',
  rons_tips_new_in_town_meta_description:
    'Stay in the know with what’s new! Ron shares the latest cafés, shops, bars, and creative spaces you should check out.',
  rons_tips_shopping_meta_title:
    'Ron’s Shopping Tips – Hidden Stores & Local Finds',
  rons_tips_shopping_meta_description:
    'Shop smarter with Ron’s picks! Discover unique boutiques, concept stores, second-hand gems, and cool local shops.',
  rons_tips_contest_meta_title: 'Ron’s Contests – Join & Win Fun Local Prizes',
  rons_tips_contest_meta_description:
    'Take part in Ron’s latest contests! Enter to win cool prizes, discover new local gems, and get involved in the community in a fun way.',
  rons_tips_people_meta_title:
    'Ron’s People – Local Faces, Stories & Creative Minds',
  rons_tips_people_meta_description:
    'Meet the people behind the city vibe! Discover interviews, stories, and insights from inspiring locals, artists, and changemakers.',
  rons_tips_out_of_town_meta_title:
    'Ron’s Out of Town Tips – Day Trips, Nature & Escapes',
  rons_tips_out_of_town_meta_description:
    'Take a break with Ron’s favorite out-of-town ideas! Discover scenic getaways, countryside spots, and relaxing adventures beyond the city.',
  about_ron_meta_title: 'About Ron',
  about_ron_meta_description: 'About Ron',
  terms_and_conditions_meta_title: 'Terms & Conditions | Ron Orp',
  terms_and_conditions_meta_description: 'Terms & Conditions | Ron Orp',
  privacy_policy_meta_title: 'Privacy Policy | Ron ORP',
  privacy_policy_meta_description: 'Privacy Policy | Ron ORP',
  advertise_on_ron_orp_meta_title:
    'Advertise on Ron Orp – Target Local Audiences with Effective Ads',
  advertise_on_ron_orp_meta_description:
    'Advertise on Ron Orp to reach a highly engaged local audience and grow your business.',
  place_ad_on_website_meta_title:
    'Place an Ad on Ron Orp – Promote Your Business or Event Online',
  place_ad_on_website_meta_description:
    'Place your ad on Ron Orp’s website and reach more local customers for your business or event.',
  post_in_newsletter_meta_title:
    'Post in Newsletter – Reach Thousands of Local Readers with Ron Orp',
  post_in_newsletter_meta_description:
    'Promote your offer or event in Ron Orp’s newsletter and connect with thousands of local readers.',
  top_placement_meta_title:
    'Top Placement – Boost Your Ad Visibility on Ron Orp',
  top_placement_meta_description:
    'Boost your ad’s visibility with Top Placement on Ron Orp and reach more potential customers in your city.',
  start_new_discussion_meta_title: 'Start New Discussion | Community',
  start_new_discussion_meta_description: 'Start New Discussion | Community',
  create_story_meta_title: 'Create Story | Community',
  create_story_meta_description: 'Create Story | Community',
  create_survey_meta_title: 'Create Survey | Community',
  create_survey_meta_description: 'Create Survey | Community',
  create_phototrip_meta_title: 'Create Phototrip | Community',
  create_phototrip_meta_description: 'Create Phototrip | Community',
  create_together_event_meta_title: 'Create Together Event | Community',
  create_together_event_meta_description: 'Create Together Event | Community',
  love_registration_meta_title: 'Love Registration',
  love_registration_meta_description: 'Love Registration',
  place_ad_meta_title: 'Place Advertisement | Market',
  place_ad_meta_description: 'Place Advertisement | Market',
  create_events_meta_title: 'Create Events | Market',
  create_events_meta_description: 'Create Events | Market',
  create_housing_meta_title: 'Create Housing | Market',
  create_housing_meta_description: 'Create Housing | Market',
  create_secondhand_meta_title: 'Create Secondhand | Market',
  create_secondhand_meta_description: 'Create Secondhand | Market',
  create_jobs_meta_title: 'Create Jobs | Market',
  create_jobs_meta_description: 'Create Jobs | Market',
  create_city_offer_meta_title: 'Create City Offer | Market',
  create_city_offer_meta_description: 'Create City Offer | Market',
  create_create_commercial_meta_title: 'Create Commercial | Market',
  create_create_commercial_meta_description: 'Create Commercial | Market',
  newsletter_archive_meta_title:
    'Ron’s Newsletter Archive – Browse Past Editions',
  newsletter_archive_meta_description:
    'Catch up on past Ron newsletters! Revisit tips, discoveries, and hidden gems from previous issues you might have missed.',
  market_for_you_meta_title: 'Market – For You: Curated Offers, Jobs & Events',
  market_for_you_meta_description:
    'Discover market listings just for you! Browse personalized ads, job posts, events, and offers picked based on your interests.',
  rons_tips_for_you_meta_title:
    'Ron’s Tips – Smart Ideas & Local Insights You’ll Love',
  rons_tips_for_you_meta_description:
    'Get inspired with Ron’s best tips! Discover fun ideas, local secrets, and cool places to eat, drink, shop, and explore wherever you are.',
  community_for_you_meta_title:
    'Community – For You: Curated Offers, Jobs & Events',
  community_for_you_meta_description:
    'Discover community listings just for you! Browse personalized ads, job posts, events, and offers picked based on your interests.',
};

const fr_meta = {
  community_home_meta_title:
    'Communauté de Ron – Échanger, poser des questions & créer des liens',
  community_home_meta_description:
    "Participe à la communauté ! Pose tes questions, partage tes idées et discute avec d'autres personnes autour de sujets qui t'inspirent.",
  ask_romandie_meta_title: 'Communauté de Ron – Explore les sujets tendance',
  ask_romandie_meta_description:
    "Rejoins la discussion dans cette catégorie populaire de la Communauté Ron ! Partage tes idées, pose tes questions et connecte-toi avec d'autres passionnés.",
  ask_swiss_meta_title: 'Communauté de Ron – Propose ou demande de l’aide',
  ask_swiss_meta_description:
    'Besoin d’un coup de main ou envie d’aider ? Cette section permet d’échanger des services et de soutenir la communauté.',
  together_meta_title: 'Communauté de Ron – Découvre ou publie des événements',
  together_meta_description:
    'Tu cherches quoi faire ? Découvre les événements postés par la communauté ou propose tes propres sorties et activités.',
  love_meta_title: 'Communauté de Ron – Explore les sujets tendance',
  love_meta_description:
    "Rejoins la discussion dans cette catégorie populaire de la Communauté Ron ! Partage tes idées, pose tes questions et connecte-toi avec d'autres passionnés.",
  phototrip_meta_title: 'Communauté de Ron – Explore les sujets tendance',
  phototrip_meta_description:
    "Rejoins la discussion dans cette catégorie populaire de la Communauté Ron ! Partage tes idées, pose tes questions et connecte-toi avec d'autres passionnés.",
  ronster_help_ronster_meta_title:
    'Communauté de Ron – Propose ou demande de l’aide',
  ronster_help_ronster_meta_description:
    'Besoin d’un coup de main ou envie d’aider ? Cette section permet d’échanger des services et de soutenir la communauté.',
  my_area_meta_title: 'Communauté de Ron – Explore les sujets tendance',
  my_area_meta_description:
    "Rejoins la discussion dans cette catégorie populaire de la Communauté Ron ! Partage tes idées, pose tes questions et connecte-toi avec d'autres passionnés.",
  rons_tips_home_meta_title:
    'Les conseils de Ron – Astuces & idées locales à découvrir',
  rons_tips_home_meta_description:
    'Découvre les meilleurs conseils de Ron ! Bons plans, lieux secrets et idées sympas pour manger, boire, faire du shopping et explorer.',
  market_home_meta_title:
    'Le Marché de Ron – Bons plans, offres, jobs & événements',
  market_home_meta_description:
    'Parcours les dernières annonces de la communauté ! Jobs, sorties, services, objets ou événements – ou publie ton propre contenu.',
  rons_tips_guides_meta_title:
    'Guides de Ron – Astuces, idées et inspirations pratiques',
  rons_tips_guides_meta_description:
    'Parcourez les meilleurs guides de Ron ! Conseils pratiques, idées utiles et astuces inspirantes pour améliorer votre quotidien.',
  rons_tips_family_life_meta_title:
    'Vie de famille avec Ron – Activités, conseils & inspirations',
  rons_tips_family_life_meta_description:
    'Des idées et conseils pour toute la famille ! Sorties, astuces parentales et activités pour petits et grands à partager ensemble.',
  rons_tips_family_life_diy_meta_title:
    'DIY avec Ron – Projets créatifs pour tous les âges',
  rons_tips_family_life_diy_meta_description:
    'Inspire-toi avec les idées DIY de Ron ! Bricolage, récup’, astuces maison et activités manuelles pour petits et grands.',
  rons_tips_family_life_finance_meta_title:
    'Finance familiale avec Ron – Astuces pour mieux gérer',
  rons_tips_family_life_finance_meta_description:
    'Gère ton budget familial avec les conseils de Ron ! Astuces d’épargne, gestion du quotidien et idées simples pour dépenser malin.',
  rons_tips_family_life_parenthood_meta_title:
    'Conseils parentalité de Ron – Astuces & expériences de vie',
  rons_tips_family_life_parenthood_meta_description:
    'Découvre les conseils de Ron pour les parents ! Trucs du quotidien, récits sincères et idées utiles pour mieux vivre la parentalité.',
  rons_tips_family_life_podcasts_meta_title:
    'Podcasts famille de Ron – Apprendre, rire et partager',
  rons_tips_family_life_podcasts_meta_description:
    'Écoute les meilleurs podcasts familiaux de Ron ! Conseils parentaux, histoires inspirantes et moments drôles à vivre ensemble.',
  rons_tips_family_life_trips_meta_title:
    'Escapades familiales de Ron – Nature, balades & sorties',
  rons_tips_family_life_trips_meta_description:
    'Découvre des idées de sorties familiales avec Ron ! Petits voyages, balades en nature et moments à partager ensemble.',
  rons_tips_family_life_inspiration_meta_title:
    'Inspirations famille de Ron – Idées pour égayer le quotidien',
  rons_tips_family_life_inspiration_meta_description:
    "Trouve de l'inspiration pour ta vie de famille ! Histoires vraies, conseils positifs et idées pour créer de beaux moments ensemble.",
  rons_tips_city_life_meta_title:
    'Guides City Life de Ron – Culture urbaine & idées de tous les jours',
  rons_tips_city_life_meta_description:
    'Découvre la vie urbaine avec les conseils de Ron ! Bons plans, culture locale, idées pratiques et inspirations pour mieux profiter de ta ville.',
  rons_tips_whats_up_meta_title: 'Quoi de neuf de Ron',
  rons_tips_whats_up_meta_description:
    'Restez informé des événements et actualités de votre ville.',
  rons_tips_balance_day_meta_title: 'Journée équilibre de Ron',
  rons_tips_balance_day_meta_description:
    'Atteignez l’équilibre avec les astuces pratiques de Ron.',
  rons_tips_pastime_meta_title:
    'Loisirs avec Ron – Activités, détente & inspirations',
  rons_tips_pastime_meta_description:
    'Trouve des idées pour tes loisirs avec Ron ! Activités créatives, détente et bons plans pour profiter pleinement de ton temps libre.',
  rons_tips_ron_voyage_meta_title: 'Ron Voyage',
  rons_tips_ron_voyage_meta_description:
    'Votre guide pour des voyages passionnants avec Ron.',
  rons_tips_roncast_meta_title: 'Roncast – Écoute, découvre et inspire-toi',
  rons_tips_roncast_meta_description:
    "Écoute Roncast pour des histoires locales, des tendances lifestyle et une dose d'inspiration à tout moment, où que tu sois.",
  rons_tips_rooftop_day_meta_title: 'Journée Rooftop de Ron',
  rons_tips_rooftop_day_meta_description:
    'Célébrez la Journée Rooftop avec les événements exclusifs de Ron.',
  rons_tips_streetfood_tour_meta_title: 'Tour de streetfood de Ron',
  rons_tips_streetfood_tour_meta_description:
    'Partez à la découverte du street food avec Ron.',
  rons_tips_whats_happening_meta_title:
    'Événements de Ron – Bons plans et sorties à ne pas manquer',
  rons_tips_whats_happening_meta_description:
    'Découvre les meilleurs événements avec Ron ! Sorties originales, culture, concerts et bons plans à vivre près de chez toi.',
  rons_tips_rons_events_meta_title:
    'Événements de Ron – Bons plans et sorties à ne pas manquer',
  rons_tips_rons_events_meta_description:
    'Découvre les meilleurs événements avec Ron ! Sorties originales, culture, concerts et bons plans à vivre près de chez toi.',
  rons_tips_food_and_shop_meta_title:
    'Bouffe & Shopping avec Ron – Saveurs et bonnes adresses',
  rons_tips_food_and_shop_meta_description:
    'Découvre les adresses food & shopping de Ron ! Restaurants savoureux, cafés sympas, marchés locaux et boutiques insolites.',
  rons_tips_food_and_drinks_meta_title:
    'Ron – Food & Drinks : Saveurs locales & bonnes adresses',
  rons_tips_food_and_drinks_meta_description:
    'Explore les meilleures adresses food & drinks de Ron ! Cafés chaleureux, bars branchés et restaurants à découvrir.',
  rons_tips_new_in_town_meta_title:
    'Nouveautés en ville – Nouveaux lieux & adresses tendances',
  rons_tips_new_in_town_meta_description:
    'Découvre les nouveautés avec Ron ! Cafés récents, nouvelles boutiques, bars stylés et lieux créatifs à explorer.',
  rons_tips_shopping_meta_title:
    'Bons plans shopping de Ron – Boutiques & trouvailles locales',
  rons_tips_shopping_meta_description:
    'Fais ton shopping avec les conseils de Ron ! Boutiques originales, friperies, concept stores et adresses locales à ne pas manquer.',
  rons_tips_contest_meta_title:
    'Concours de Ron – Participe & gagne des surprises locales',
  rons_tips_contest_meta_description:
    'Participe aux concours de Ron ! Remporte des cadeaux, découvre de nouveaux endroits et amuse-toi avec la communauté locale..',
  rons_tips_people_meta_title: 'Ron – Portraits & histoires de gens inspirants',
  rons_tips_people_meta_description:
    'Rencontre les personnes qui font vibrer ta ville ! Interviews, récits et idées de locaux, artistes et esprits créatifs.',
  rons_tips_out_of_town_meta_title:
    'Ron – Escapades hors de la ville : nature & découvertes',
  rons_tips_out_of_town_meta_description:
    'Besoin d’évasion ? Ron partage ses idées d’escapades : balades, paysages, nature et lieux à explorer hors des sentiers battus.',
  about_ron_meta_title: 'À propos de Ron',
  about_ron_meta_description:
    'Découvrez-en plus sur Ron et la vision derrière la plateforme.',
  terms_and_conditions_meta_title: 'Termes et conditions',
  terms_and_conditions_meta_description:
    'Comprenez les termes et conditions d’utilisation de Ron Orp.',
  privacy_policy_meta_title: 'Politique de confidentialité',
  privacy_policy_meta_description:
    'Lisez notre politique de confidentialité pour savoir comment nous protégeons vos données.',
  advertise_on_ron_orp_meta_title:
    'Publicité sur Ron Orp – Touchez des audiences locales efficacement',
  advertise_on_ron_orp_meta_description:
    'Faites la promotion de votre activité sur Ron Orp pour atteindre une audience locale engagée et développer votre entreprise.',
  place_ad_on_website_meta_title:
    'Placer une annonce sur Ron Orp – Promotion de votre entreprise ou événement',
  place_ad_on_website_meta_description:
    'Placez votre annonce sur le site Ron Orp et touchez plus de clients locaux pour votre entreprise ou événement.',
  post_in_newsletter_meta_title:
    'Publier dans la newsletter – Touchez des milliers de lecteurs locaux',
  post_in_newsletter_meta_description:
    'Faites la promotion de votre offre ou événement dans la newsletter Ron Orp et touchez des milliers de lecteurs locaux.',
  top_placement_meta_title:
    'Placement premium – Maximisez la visibilité de votre annonce sur Ron Orp',
  top_placement_meta_description:
    'Maximisez la visibilité de votre annonce avec un placement premium sur Ron Orp et touchez plus de clients potentiels dans votre ville.',
  start_new_discussion_meta_title: 'Commencer une discussion',
  start_new_discussion_meta_description:
    'Engagez des discussions avec des membres partageant les mêmes idées.',
  create_story_meta_title: 'Créer une histoire',
  create_story_meta_description:
    'Partagez votre histoire avec la communauté Ron.',
  create_survey_meta_title: 'Créer une enquête',
  create_survey_meta_description:
    'Obtenez des réponses et engagez la communauté avec une enquête.',
  create_phototrip_meta_title: 'Créer une phototrip',
  create_phototrip_meta_description:
    'Montrez vos talents en photographie avec une phototrip.',
  create_together_event_meta_title: 'Créer un événement ensemble',
  create_together_event_meta_description:
    'Organisez des événements et connectez-vous avec d’autres.',
  love_registration_meta_title: 'Inscription amour',
  love_registration_meta_description:
    'Trouvez l’amour et des connexions significatives avec Ron.',
  place_ad_meta_title: 'Anzeige schalten',
  place_ad_meta_description:
    'Annoncez vos services et produits sur le Marché de Ron.',
  create_events_meta_title: 'Créer des événements',
  create_events_meta_description:
    'Faites la promotion de vos événements sur le Marché Ron.',
  create_housing_meta_title: 'Créer un logement',
  create_housing_meta_description:
    'Listez vos offres de logement et connectez-vous avec locataires ou acheteurs.',
  create_secondhand_meta_title: 'Créer une seconde main',
  create_secondhand_meta_description:
    'Vendez vos objets de seconde main facilement sur le Marché Ron.',
  create_jobs_meta_title: 'Créer des emplois',
  create_jobs_meta_description:
    'Annoncez vos offres d’emploi et connectez-vous aux talents.',
  create_city_offer_meta_title: 'Créer une offre urbaine',
  create_city_offer_meta_description:
    'Faites la promotion de vos offres urbaines à la communauté Ron.',
  create_create_commercial_meta_title: 'Créer un commercial',
  create_create_commercial_meta_description:
    'Annoncez votre entreprise sur la plateforme de Ron.',
  newsletter_archive_meta_title:
    'Archives des newsletters de Ron – Redécouvre les anciennes éditions',
  newsletter_archive_meta_description:
    'Consulte les anciennes newsletters de Ron ! Astuces, bons plans et trouvailles à ne pas manquer dans les éditions passées.',
  market_for_you_meta_title:
    'Marché – Pour toi : offres, événements et jobs sélectionnés',
  market_for_you_meta_description:
    'Parcours des annonces faites pour toi ! Jobs, événements et bons plans recommandés selon tes préférences.',
  rons_tips_for_you_meta_title:
    'Les conseils de Ron – Astuces & idées locales à découvrir',
  rons_tips_for_you_meta_description:
    'Découvre les meilleurs conseils de Ron ! Bons plans, lieux secrets et idées sympas pour manger, boire, faire du shopping et explorer.',
  community_for_you_meta_title:
    'Communauté – Pour toi : offres, jobs & événements sélectionnés',
  community_for_you_meta_description:
    'Parcours des annonces communautaires faites pour toi ! Découvre des annonces personnalisées, offres d’emploi, événements et bons plans selon tes intérêts.',
};

const de_meta = {
  community_home_meta_title: 'Ron’s Community – Fragen, teilen & vernetzen',
  community_home_meta_description:
    'Werde Teil der Community! Stelle Fragen, teile Gedanken, hol dir Tipps und finde Gleichgesinnte im urbanen Austausch.',
  ask_swiss_meta_title: 'Ron’s Community – Hilfe suchen & anbieten',
  ask_swiss_meta_description:
    'Du brauchst Unterstützung oder willst helfen? In dieser Kategorie kannst du Dienstleistungen teilen oder Hilfe in der Community finden.',
  ask_zurich_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_zurich_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ask_basel_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_basel_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ask_bern_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_bern_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ask_luzern_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_luzern_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ask_winterthur_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_winterthur_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ask_st_gallen_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  ask_st_gallen_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  zurie_family_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  zurie_family_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  together_meta_title: 'Ron’s Community – Events entdecken & selbst posten',
  together_meta_description:
    'Auf der Suche nach Events? Finde Veranstaltungen aus der Community oder teile deine eigenen Erlebnisse und Aktivitäten.',
  love_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  love_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  phototrip_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  phototrip_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  ronster_help_ronster_meta_title: 'Ron’s Community – Hilfe suchen & anbieten',
  ronster_help_ronster_meta_description:
    'Du brauchst Unterstützung oder willst helfen? In dieser Kategorie kannst du Dienstleistungen teilen oder Hilfe in der Community finden.',
  my_area_meta_title: 'Ron’s Community – Entdecke trendige Themen',
  my_area_meta_description:
    'Diskutiere mit in dieser beliebten Kategorie der Ron’s Community! Teile deine Gedanken, stelle Fragen und vernetze dich mit anderen Interessierten.',
  rons_tips_home_meta_title:
    'Ron’s Tipps – Schlaue Ideen & lokale Empfehlungen',
  rons_tips_home_meta_description:
    'Lass dich von Ron’s Tipps inspirieren! Finde spannende Ideen, geheime Orte und tolle Plätze zum Essen, Trinken, Shoppen und Entdecken.',
  market_home_meta_title:
    'Ron’s Marktplatz – Finde Events, Jobs, Angebote & mehr',
  market_home_meta_description:
    'Entdecke, was die Community zu bieten hat! Events, Dienstleistungen, Jobs und besondere Angebote – oder poste selbst etwas.',
  rons_tips_guides_meta_title:
    'Ron’s Tipps Guides – Die besten Ideen & Lifehacks',
  rons_tips_guides_meta_description:
    'Entdecke die beliebtesten Guides von Ron! Praktische Tipps, clevere Lifehacks und Inspiration für deinen Alltag.',
  rons_tips_family_life_meta_title:
    'Familienleben mit Ron – Tipps, Ausflüge & Alltagsspaß',
  rons_tips_family_life_meta_description:
    'Hol dir Inspiration für das Familienleben! Mit Ausflugstipps, Elternhacks und kreativen Aktivitäten für Groß und Klein.',
  rons_tips_family_life_diy_meta_title:
    'Ron’s DIY Tipps – Kreative Projekte für Groß & Klein',
  rons_tips_family_life_diy_meta_description:
    'Lass dich von Ron’s DIY-Tipps begeistern! Bastelideen, Upcycling, Wohntipps und Aktivitäten für Kinder und Erwachsene.',
  rons_tips_family_life_finance_meta_title:
    'Ron’s Familientipps – Geld sparen & clever haushalten',
  rons_tips_family_life_finance_meta_description:
    'Finde hilfreiche Spartipps für Familien! Von Budgetplanung über Alltagstricks bis zu cleveren Finanzideen für ein entspanntes Leben.',
  rons_tips_family_life_parenthood_meta_title:
    'Ron’s Eltern-Tipps – Erfahrungen, Rat & Familienalltag',
  rons_tips_family_life_parenthood_meta_description:
    'Hol dir Unterstützung für deinen Elternalltag! Praktische Tipps, ehrliche Geschichten und clevere Ideen rund ums Elternsein.',
  rons_tips_family_life_podcasts_meta_title:
    'Ron’s Familien-Podcasts – Zuhören, lernen & gemeinsam lachen',
  rons_tips_family_life_podcasts_meta_description:
    'Lausche spannenden Podcasts für die ganze Familie! Mit Erziehungstipps, Alltagsgeschichten und Inspiration für Groß und Klein.',
  rons_tips_family_life_trips_meta_title:
    'Ron’s Familienausflüge – Kurztrips & Naturerlebnisse',
  rons_tips_family_life_trips_meta_description:
    'Plane den nächsten Familienausflug mit Ron! Ob Wochenendtrip, Wanderung oder Abenteuer – für Groß und Klein ist etwas dabei.',
  rons_tips_family_life_inspiration_meta_title:
    'Ron’s Familieninspiration – Ideen für mehr Freude im Alltag',
  rons_tips_family_life_inspiration_meta_description:
    'Lass dich inspirieren von Ron! Kreative Impulse, ehrliche Geschichten und Tipps für mehr Leichtigkeit im Familienleben.',
  rons_tips_city_life_meta_title:
    'Ron’s City Life Guides – Stadtleben erleben & genießen',
  rons_tips_city_life_meta_description:
    'Entdecke das Stadtleben mit Ron’s Tipps! Finde tolle Orte, urbane Kultur, Alltagstipps und neue Inspiration für dein Leben in der Stadt.',
  rons_tips_whats_up_meta_title: 'Was läuft',
  rons_tips_whats_up_meta_description:
    'Bleiben Sie über Events und Neuigkeiten in Ihrer Stadt informiert.',
  rons_tips_balance_day_meta_title: 'Balance Day',
  rons_tips_balance_day_meta_description:
    'Finden Sie Balance mit praktischen Tipps von Ron.',
  rons_tips_pastime_meta_title:
    'Ron’s Freizeit-Tipps – Hobbys, Spaß & gute Ideen',
  rons_tips_pastime_meta_description:
    'Entdecke neue Freizeitideen mit Ron! Von spannenden Hobbys bis zu entspannenden Aktivitäten – perfekt für den Feierabend oder das Wochenende.',
  rons_tips_ron_voyage_meta_title: 'Ron Reise',
  rons_tips_ron_voyage_meta_description:
    'Ihr Guide für spannende Reisen mit Ron.',
  rons_tips_roncast_meta_title:
    'Roncast – Zuhören, lernen & inspirieren lassen',
  rons_tips_roncast_meta_description:
    'Höre dir Roncast an: spannende Geschichten, Trends, lokale Einblicke und kreative Inspiration für unterwegs oder zu Hause.',
  rons_tips_rooftop_day_meta_title: 'Rooftop Day',
  rons_tips_rooftop_day_meta_description:
    'Feiern Sie den Rooftop Day mit Rons exklusiven Tipps.',
  rons_tips_streetfood_tour_meta_title: 'Streetfood Tour',
  rons_tips_streetfood_tour_meta_description:
    'Entdecken Sie Streetfood mit Rons Empfehlungen.',
  rons_tips_whats_happening_meta_title:
    'Ron’s Events – Besondere Events & kulturelle Highlights',
  rons_tips_whats_happening_meta_description:
    'Verpasse keine spannenden Events! Ron zeigt dir besondere Veranstaltungen, kulturelle Tipps und lokale Highlights.',
  rons_tips_rons_events_meta_title:
    'Ron’s Events – Besondere Events & kulturelle Highlights',
  rons_tips_rons_events_meta_description:
    'Verpasse keine spannenden Events! Ron zeigt dir besondere Veranstaltungen, kulturelle Tipps und lokale Highlights.',
  rons_tips_food_and_shop_meta_title:
    'Essen & Einkaufen mit Ron – Genuss & Geheimtipps',
  rons_tips_food_and_shop_meta_description:
    'Entdecke mit Ron kulinarische Highlights und besondere Läden! Von leckeren Restaurants bis zu charmanten Shops und Märkten.',
  rons_tips_food_and_drinks_meta_title:
    'Ron’s Food & Drinks – Kulinarische Highlights & Tipps',
  rons_tips_food_and_drinks_meta_description:
    'Entdecke leckere Orte mit Ron! Ob Café, Bar oder Restaurant – hier findest du Genuss, Geschmack und echte Insider-Tipps.',
  rons_tips_new_in_town_meta_title:
    'Neu in der Stadt – Neue Orte, Eröffnungen & Insider-Tipps',
  rons_tips_new_in_town_meta_description:
    'Entdecke das Neueste in deiner Stadt! Ron zeigt dir frisch eröffnete Cafés, Läden, Bars und kreative Hotspots.',
  rons_tips_shopping_meta_title:
    'Ron’s Shopping Tipps – Versteckte Läden & lokale Funde',
  rons_tips_shopping_meta_description:
    'Entdecke mit Ron besondere Shops! Von kleinen Boutiquen über Secondhand-Schätze bis zu stylischen Concept Stores.',
  rons_tips_contest_meta_title:
    'Ron’s Wettbewerbe – Mitmachen & tolle Preise gewinnen',
  rons_tips_contest_meta_description:
    'Mach mit bei Ron’s Gewinnspielen! Gewinne attraktive Preise, entdecke neue Lieblingsorte und werde Teil einer aktiven Community.',
  rons_tips_people_meta_title:
    'Ron’s People – Gesichter, Geschichten & kreative Köpfe',
  rons_tips_people_meta_description:
    'Lerne spannende Menschen kennen! Interviews, Porträts und Einblicke in das Leben von Kreativen, Visionären und Lokalheld:innen.',
  rons_tips_out_of_town_meta_title:
    'Ron’s Ausflugstipps – Raus ins Grüne & neue Orte entdecken',
  rons_tips_out_of_town_meta_description:
    'Lust auf Tapetenwechsel? Ron zeigt dir schöne Ausflugsziele, Naturerlebnisse und entspannte Orte fernab vom Stadttrubel.',
  about_ron_meta_title: 'Über Ron',
  about_ron_meta_description:
    'Erfahren Sie mehr über Ron und die Vision hinter der Plattform.',
  terms_and_conditions_meta_title: 'Termes et conditions | Ron Orp',
  terms_and_conditions_meta_description:
    'Comprenez les termes et conditions d’utilisation de Ron Orp.',
  privacy_policy_meta_title: 'Ron ORP | Datenschutzrichtlinien',
  privacy_policy_meta_description:
    'Lisez notre politique de confidentialité pour comprendre comment vos données sont protégées.',
  advertise_on_ron_orp_meta_title:
    'Werbung auf Ron Orp – Lokale Zielgruppen effektiv erreichen',
  advertise_on_ron_orp_meta_description:
    'Werben Sie auf Ron Orp, um eine engagierte lokale Zielgruppe zu erreichen und Ihr Geschäft auszubauen.',
  place_ad_on_website_meta_title:
    'Anzeige auf Ron Orp schalten – Bewerben Sie Ihr Unternehmen oder Event online',
  place_ad_on_website_meta_description:
    'Schalten Sie Ihre Anzeige auf der Ron Orp Website und erreichen Sie mehr lokale Kunden für Ihr Unternehmen oder Event.',
  post_in_newsletter_meta_title:
    'Im Newsletter werben – Erreichen Sie Tausende lokale Leser mit Ron Orp',
  post_in_newsletter_meta_description:
    'Bewerben Sie Ihr Angebot oder Event im Ron Orp Newsletter und erreichen Sie Tausende lokale Leser.',
  top_placement_meta_title:
    'Top-Platzierung – Steigern Sie die Sichtbarkeit Ihrer Anzeige auf Ron Orp',
  top_placement_meta_description:
    'Steigern Sie die Sichtbarkeit Ihrer Anzeige mit einer Top-Platzierung auf Ron Orp und erreichen Sie mehr potenzielle Kunden in Ihrer Stadt.',
  start_new_discussion_meta_title: 'Communauté | Diskussion starten',
  start_new_discussion_meta_description:
    'Engagez des discussions avec des membres de la communauté.',
  create_story_meta_title: 'Communauté | Geschichte erstellen',
  create_story_meta_description:
    'Partagez votre histoire avec la communauté Ron.',
  create_survey_meta_title: 'Umfrage erstellen | Gemeinschaft',
  create_survey_meta_description: 'Umfrage erstellen | Gemeinschaft',
  create_phototrip_meta_title: 'Communauté | Phototrip erstellen',
  create_phototrip_meta_description:
    'Montrez vos talents en photographie avec une phototrip.',
  create_together_event_meta_title: 'Communauté | Ereignis erstellen',
  create_together_event_meta_description:
    'Organisez des événements et connectez-vous avec d’autres.',
  love_registration_meta_title: 'Liebesregistrierung',
  love_registration_meta_description:
    'Finden Sie Liebe und bedeutsame Verbindungen mit Ron.',
  place_ad_meta_title: 'Anzeige schalten',
  place_ad_meta_description:
    'Faites la publicité de vos services et produits sur le Marché Ron.',
  create_events_meta_title: 'Veranstaltungen erstellen',
  create_events_meta_description:
    'Faites la promotion de vos événements sur le Marché Ron.',
  create_housing_meta_title: 'Wohnen erstellen',
  create_housing_meta_description:
    'Publiez vos offres de logement und connectez-vous mit Käufern.',
  create_secondhand_meta_title: 'Secondhand erstellen',
  create_secondhand_meta_description:
    'Vendez facilement vos articles d’occasion sur le Marché Ron.',
  create_jobs_meta_title: 'Jobs erstellen',
  create_jobs_meta_description:
    'Publiez des offres d’emploi et connectez-vous mit Talenten.',
  create_city_offer_meta_title: 'Stadtangebote erstellen',
  create_city_offer_meta_description:
    'Promouvez vos offres urbaines à la communauté Ron.',
  create_create_commercial_meta_title: 'Werbung erstellen',
  create_create_commercial_meta_description:
    'Faites la publicité de votre entreprise mit Ron.',
  newsletter_archive_meta_title:
    'Ron’s Newsletter-Archiv – Frühere Ausgaben entdecken',
  newsletter_archive_meta_description:
    'Durchstöbere vergangene Newsletter von Ron! Finde ältere Tipps, Highlights und Empfehlungen aus früheren Ausgaben.',
  market_for_you_meta_title:
    'Marktplatz – Für dich: Persönliche Jobs, Events & Angebote',
  market_for_you_meta_description:
    'Entdecke persönliche Empfehlungen auf dem Marktplatz! Jobs, Events und Angebote, die zu deinen Interessen passen.',
  rons_tips_for_you_meta_title:
    'Ron’s Tipps – Schlaue Ideen & lokale Empfehlungen',
  rons_tips_for_you_meta_description:
    'Lass dich von Ron’s Tipps inspirieren! Finde spannende Ideen, geheime Orte und tolle Plätze zum Essen, Trinken, Shoppen und Entdecken.',
  community_for_you_meta_title:
    'Community – Für dich: Persönliche Jobs, Events & Angebote',
  community_for_you_meta_description:
    'Entdecke persönliche Empfehlungen auf der Community! Jobs, Events und Angebote, die zu deinen Interessen passen.',
};

export function getSeoMeta(city) {
  const lang = getLangBasedOnCity(city);
  if (lang === 'fr') return fr_meta;
  else if (lang === 'de') return de_meta;
  else return en_meta;
}
